import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import config from "../../../config";
import { BookingMembershipOptions, BookingSelectedMembershipData, BookingSelectedServicesData, BookingSelectedSubscriptionData, BookingSubscriptionOptions, NextStep, PreviewStep } from "store/slices/bookingSlice";
import { useDispatch } from "react-redux";
import SubscriptionStep3 from "./Step3";
import getStripeClient from "pages/getStripeClient";
import { Elements } from "@stripe/react-stripe-js";

const SubscriptionStep2 = (props) => {
    const [hidden, setHidden] = useState({});
    const dispatch = useDispatch();
    const stripePromise = getStripeClient();

    const { t } = useTranslation();
    const isBookingStep = props.isBookingStep;
    const isBookingSelectedSubscriptionData = props.isBookingSelectedSubscriptionData;
    const isBookingApi = useSelector((state) => state.booking.isBookingApi);
    const isSubscriptionOption = useSelector((state) => state.booking.isSubscriptionOption);
    const objectData = isSubscriptionOption && isSubscriptionOption.data && isSubscriptionOption.data.length > 0 ? isSubscriptionOption.data : isSubscriptionOption;
    const objectDataWithout = objectData;
    const [makePaymentinfoShow, setMakePaymentinfoShow] = useState("hide");
    console.log('makePaymentinfoShow: ', makePaymentinfoShow);

    useEffect(() => {
        dispatch(BookingSubscriptionOptions({ uid: isBookingApi && isBookingApi.uid, salon_id: isBookingApi && isBookingApi.salon && isBookingApi.salon.id }));
    }, []);

    const toggleHide = (index) => {
        setHidden({ ...hidden, [index]: !hidden[index] });
    };

    return (

        <>

            {makePaymentinfoShow === "hide" ? (
                <React.Fragment>
                    <div className="please-sele">
                        <a
                            role="button"
                            onClick={() => {
                                dispatch(PreviewStep(isBookingStep));
                            }}
                        >
                            <img src={config.imagepath + "left-arrow.svg"} alt="" className="me-3" width="21" />
                            {t("Please select a subscription")}
                        </a>
                    </div>
                    <div className="items-list">
                        <ul className="m-0 p-0">
                            {objectDataWithout && objectDataWithout.length > 0 ? (
                                Object.keys(objectDataWithout).filter(e => objectDataWithout[e]?.is_subscription_hide_online === 0).map((item, i) => {
                                    let id = objectDataWithout[item]?.id;
                                    let name = objectDataWithout[item]?.name;
                                    let terms_and_conditions = objectDataWithout[item]?.terms_and_conditions;
                                    let is_subscription_hide_online = objectDataWithout[item]?.is_subscription_hide_online;


                                    const amount = parseFloat(objectDataWithout[item]?.amount);
                                    const one_off_payments = objectDataWithout[item]?.one_off_payments == 1 ? true : false;
                                    const customFirstPayment = parseFloat(objectDataWithout[item]?.one_off_amount) || 0;
                                    const noOfPayments = objectDataWithout[item]?.no_of_payments;
                                    let subservice = objectDataWithout[item]?.subservice && objectDataWithout[item]?.subservice?.length > 0 ? objectDataWithout[item]?.subservice : [];

                                    let TotalSubscriptionCost = 0;
                                    if (!isNaN(amount) && !isNaN(noOfPayments)) {
                                        if (one_off_payments) {
                                            TotalSubscriptionCost = (amount * (noOfPayments - 1)) + customFirstPayment;
                                        } else {
                                            TotalSubscriptionCost = amount * noOfPayments;
                                        }
                                    }
                                    let activeClass = "";

                                    if (isBookingSelectedSubscriptionData?.id && isBookingSelectedSubscriptionData?.id == id) {
                                        activeClass = "active";
                                    } else if (!isBookingSelectedSubscriptionData && isBookingApi?.subscription_id == id) {
                                        activeClass = "active";
                                    }
                                    return (
                                        <div className="position-relative">
                                            <li className={"items-option " + activeClass} key={i} onClick={() => {
                                                dispatch(BookingSelectedSubscriptionData(objectDataWithout[item]));
                                                // dispatch(NextStep(isBookingStep));
                                                setMakePaymentinfoShow("show");
                                            }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h6 className="mb-0" role="button">
                                                        <a>{name}</a>
                                                    </h6>
                                                    <div>
                                                        <a className="fw-semibold me-5">${TotalSubscriptionCost}</a>
                                                    </div>
                                                </div>
                                                {!!hidden[id] && (
                                                    <div>
                                                        <p className="my-2 fw-semibold">{t("Service Included")}</p>
                                                        {subservice?.length > 0 && (
                                                            subservice.map((serviceItem, i) => {
                                                                return (
                                                                    <div className="d-flex justify-content-between" key={i}>
                                                                        <p className="m-0">{serviceItem?.services?.name}</p>
                                                                        <p className="m-0">x {serviceItem?.qty}</p>
                                                                    </div>
                                                                );
                                                            })
                                                        )}
                                                        <a
                                                            role="button"
                                                            onClick={(e) => {
                                                                e.stopPropagation(); // Prevent click from propagating to the parent li
                                                                toggleHide(id);
                                                            }}
                                                            className="text-primary mt-2"
                                                        >
                                                            <u>{t("Hide")}</u>
                                                        </a>
                                                    </div>
                                                )}
                                            </li>
                                            <a
                                                className="position-absolute"
                                                role="button"
                                                onClick={(e) => {
                                                    e.stopPropagation(); // Prevent click from propagating to the parent li
                                                    toggleHide(id);
                                                }}
                                                style={{ top: "15px", right: "15px", zIndex: 9, width: '22px' }}
                                            >
                                                <img className="" src={config.imagepath + "info.svg"} />
                                            </a>
                                        </div>
                                    );
                                })
                            ) : (
                                <li className="fw-bold items-option nodatafound">{t("No data found")}</li>
                            )}
                        </ul>
                    </div>
                </React.Fragment>
            ) : (
                <Elements stripe={stripePromise}>
                    <SubscriptionStep3 setMakePaymentinfoShow={setMakePaymentinfoShow} isBookingStep={isBookingStep} bookingStepName={'BuySubscription'} isBookingSelectedSubscriptionData={isBookingSelectedSubscriptionData} />
                </Elements>

            )}
        </>
    );
};

SubscriptionStep2.propTypes = {
    isBookingStep: PropTypes.number,
};
export default SubscriptionStep2;
